function getProductPrice(originalPrice, addedPrice, discount) {
    let finalPrice = originalPrice - (originalPrice * discount / 100.0) + addedPrice;
    return Math.round(finalPrice);
}

export default {
    getProductPrice
}